import { faNumber } from "./format";
import classes from "./home.module.scss";
import { StylistDay } from "./stylistDay";

// Segments read well up to a dozen visits; a busier day falls back to a single bar.
const MAX_SEGMENTS = 12;

// "۳ از ۷ انجام شد": one segment per visit today, finished ones filled and the one in progress highlighted.
export default function DayProgress({ day }: { day: StylistDay }) {
  if (day.total === 0) return null;
  const done = day.done.length;
  return (
    <div className={classes.dayProgress}>
      <span
        className={classes.segments}
        role="progressbar"
        aria-label="پیشرفت نوبت‌های امروز"
        aria-valuenow={done}
        aria-valuemin={0}
        aria-valuemax={day.total}
      >
        {day.total <= MAX_SEGMENTS ? (
          Array.from({ length: day.total }, (_, index) => (
            <span key={index} data-state={index < done ? "done" : index === done && day.live ? "live" : undefined} />
          ))
        ) : (
          <span data-state="done" style={{ flex: `0 0 ${Math.round((done / day.total) * 100)}%` }} />
        )}
      </span>
      <span className={classes.dayProgressText}>
        {faNumber(done)} از {faNumber(day.total)} انجام شد
      </span>
    </div>
  );
}
